import * as jsxRuntime from "/builds/pinkswan/chatbot-interface/front-end/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment